export default __webpack_public_path__ + "361e69b8a54addf7959de0b2b1290714.png";